/**
 * Service for checking system status including maintenance mode and backend version
 */

import axios from "../axiosConfig";

export interface SystemStatus {
  is_maintenance: boolean;
  maintenance_message?: string;
  end_at_datetime?: string;
  start_at_datetime?: string;
  is_scheduled: boolean;
  backend_version: string;
}

/**
 * Get system status including maintenance mode and backend version
 * This call does not require authentication
 */
export async function getSystemStatus(): Promise<SystemStatus> {
  const endpoint = "/api/v1/system-status";

  try {
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error) {
    console.error("Error checking system status:", error);
    // If there's an error, assume no maintenance and backend version
    return {
      is_maintenance: false,
      is_scheduled: false,
      backend_version: "",
    };
  }
}
